import trainingForm from './trainingForm';
import trainingTable from './trainingTable';
import wizard from './trainingWizard';
export default {
  layout: 'training-layout',
  addBtn: 'training-add-btn',
  grid: 'training-grid',
  trainingTable,
  trainingForm,
  wizard,
};
